<template src="./component.html"></template>

<script>
export default {
  name: "Advantages",
  data() {
    return {
      activeMenu: 1,
      mobileMenuActive: 0,
    }
  },
  methods: {
    onActive: function (num) {
      this.activeMenu = num;
    },
    onMobileMenuActive: function (num, e) {
      e.preventDefault();
      if (num === this.mobileMenuActive) {
        this.mobileMenuActive = '';
        return;
      }
      var id = '';
      this.mobileMenuActive = num;
      switch (num) {
        case 1:
          id = '#scroll-data-mb';
          break;
        case 2:
          id = '#scroll-best-mb';
          break;
        case 3:
          id = '#scroll-technology-mb';
          break;
        case 4:
          id = '#scroll-functionality-mb';
          break;
        case 'support':
          id = '#scroll-support-mb';
          break;
      }
      const container = this.$el.querySelector(id);
      setTimeout(function() {
        container.scrollIntoView({behavior: 'smooth'});
      }, 10);
    }
  }
}
</script>

<style src="./component.scss" scoped lang="scss"/>
